import { useNavigate } from 'react-router-dom';

import { HighlightedCTACard } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box, Grid, SxProps, Theme } from '@mui/material';

import { useGetHomePageSections } from './hooks/useGetHomePageSections';
import { Header } from './molecules/Header';
import { HomePageSection } from './molecules/HomePageSection';

const HOME_PAGE_STRINGS = appStrings.modules.home;

export const HomePage = () => {
  const navigate = useNavigate();

  const doesUserHaveBlueprint = useAppSelector(
    (state) => state.userResponseSet.mostRecentUserResponseSet?.user_responses,
  );

  const {
    getBackedYourWay,
    exploreOpportunities,
    upYourGame,
    personalHealthWellness,
    completeYourProfile,
  } = useGetHomePageSections();

  return (
    <Grid item xs={12} sx={containerSx}>
      <Header />

      <Box sx={contentContainerSx}>
        <Box sx={highlightedCardContainerSx}>
          <HighlightedCTACard
            leftImageUrl="images/image-start.svg"
            title={HOME_PAGE_STRINGS.cta.title}
            description={HOME_PAGE_STRINGS.cta.description}
            ctaText={HOME_PAGE_STRINGS.cta.ctaText}
            ctaOnClick={() =>
              navigate(doesUserHaveBlueprint ? APP_ROUTE.MY_BLUEPRINT : APP_ROUTE.INTRO)
            }
          />
        </Box>

        <HomePageSection {...getBackedYourWay} />

        <HomePageSection {...exploreOpportunities} />

        <HomePageSection {...upYourGame} />

        {/* COMPLETE YOUR PROFILE WILL GO HERE */}

        <HomePageSection {...completeYourProfile} />

        <HomePageSection {...personalHealthWellness} />
      </Box>
    </Grid>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  paddingTop: backrs.containerSpacing['container-padding-desktop'],
  paddingBottom: backrs.spacing['spacing-6xl'],
  paddingLeft: `${backrs.spacing['spacing-none']} !important`,
  overflowY: 'auto',
  height: 'fit-content',
  maxWidth: '1144px !important', // 1144 is the max width of the template in Figma
  margin: '0 auto',
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  paddingX: {
    xs: backrs.spacing['spacing-2xl'],
    sm: backrs.spacing['spacing-4xl'],
    md: backrs.spacing['spacing-7xl'],
    lg: backrs.spacing['spacing-9xl'],
  },
});

const highlightedCardContainerSx: SxProps<Theme> = ({ backrs }) => ({
  marginTop: backrs.spacing['spacing-4xl'],
});
